import React from 'react';
import { Box } from '@wix/design-system';
import s from './SaleIcon.scss';
import SaleIconSvg from '../../assets/icons/sale-icon.svg';
export const SaleIcon = ({ bgColor, fillColor }) => {
    const svgStyle = {
        style: {
            ['--svg-fill-color']: fillColor ?? s.saleDefaultColor,
        },
    };
    return (React.createElement(Box, { dataHook: "sale-icon", className: s.saleIconContainer, backgroundColor: bgColor ?? s.saleDefaultSecondaryColor },
        React.createElement(SaleIconSvg, { ...svgStyle })));
};
//# sourceMappingURL=SaleIcon.js.map